<template>
  <v-text-field
    :value="value"
    :label="label"
    :type="shown ? 'text' : 'password'"
    :placeholder="placeholder"
    class="secret-field"
    prepend-inner-icon="mdi-key-variant"
    autocomplete="off"
    spellcheck="false"
    dir="ltr"
    outlined
    dense
    hide-details
    @input="$emit('input', $event)"
  >
    <template v-slot:append>
      <button type="button" class="secret-field__btn" :aria-label="$t('show')" @click="shown = !shown">
        <v-icon small>{{ shown ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
      </button>
      <button v-if="value" type="button" class="secret-field__btn" :aria-label="$t('copy')" @click="copy">
        <v-icon small :color="copied ? 'success' : null">{{ copied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
      </button>
    </template>
  </v-text-field>
</template>

<script>
// API key / token input: masked by default, with show/hide and copy.
// UI state lives here so pages that post their whole $data stay clean.
export default {
  name: 'SecretField',
  props: {
    value: { type: String, default: null },
    label: { type: String, default: '' },
    placeholder: { type: String, default: null },
  },
  data: () => ({ shown: false, copied: false }),
  methods: {
    copy () {
      if (!this.value || !navigator.clipboard) return
      navigator.clipboard.writeText(this.value).then(() => {
        this.copied = true
        setTimeout(() => { this.copied = false }, 1500)
      }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.secret-field ::v-deep input {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: 0.02em;
}
.secret-field ::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
  gap: 2px;
  display: flex;
}
.secret-field__btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
}
.secret-field__btn:hover { background: rgba(0, 0, 0, 0.06); }
</style>
